import { Subscription } from "./subscription";

export interface User {
    id: string;
    name: string;
    surname: string;
    email: string;
    type: UserType;
    role: UserRole;
    status: UserStatus;
    acquiredContentIdList: string[];
    favoriteContentIdList: string[];
    likedContentIdList: string[];
    identityProviderId: string;
    birthDate: Date;
    newsletterConsent: boolean;
    tosConsent: boolean;
    sex: Sex;
    stripeData: UserStripeData;
    subscriptionData: UserSubscriptionData;
    preRegistrationToken: string;
}

export interface SubscriptionData {
    subscriptionReference: any,
    planStartDate: Date,
    planEndDate: Date | null
}

export enum UserRole {
    END_USER = "END_USER",
    PRODUCER = "PRODUCER",
    ADMIN = "ADMIN",
    CHIEF_PRODUCER = "CHIEF_PRODUCER",
    GUEST = "GUEST",
    ANALYST = "ANALYST"
}

export enum UserStatus {
    CONFIRMED = "CONFIRMED",
    NOT_CONFIRMED = "NOT_CONFIRMED",
    DISABLED = "DISABLED"
}

export enum UserType {
    FREE = "FREE",
    MONTHLY= "MONTHLY",
    YEARLY = "YEARLY"
}

export enum Sex {
    M = "M",
    F = "F",
    O = "O"
}

export interface UserStripeData {
    customerId?: string,
    subscriptionId?: string
    paymentMethod?: UserStripePaymentMethodData
}

export interface UserStripePaymentMethodData {
    defaultPaymentMethod?: string,
    brand?: string,
    expMonth?: number,
    expYear?: number,
    last4?: string
}

export enum SubscriptionStatus {
    ACTIVE = "ACTIVE",
    SUSPENDED_BY_USER = "SUSPENDED_BY_USER",
    PAST_DUE = "PAST_DUE"
}

export interface UserSubscriptionData {
    startDate?: Date,
    endDate?: Date,
    subscriptionItem?: Subscription,
    status?: SubscriptionStatus
}